import { render, staticRenderFns } from "./SupplierView.vue?vue&type=template&id=7ddaf9f2&scoped=true"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"
import style0 from "./SupplierView.vue?vue&type=style&index=0&id=7ddaf9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddaf9f2",
  null
  
)

export default component.exports